import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'app-hr-rendered',
  templateUrl: './hr-rendered.component.html',
  styleUrls: ['./hr-rendered.component.css']
})
export class HrRenderedComponent extends ElementComponent {
  @Input() override data: any = {

  }
}
